<template>
  <div class="col-sm-12">
    <collapse :active-index="0">
      <collapse-item>
        <template slot="title">
          <div class="row">
            <div class="col">
              <h3 class="mb-0">Listado de fechas Límite</h3>
            </div>
          </div>
        </template>
        <ul class="list-group list-group-flush list my--3">
          <li v-for="(date, index) in dates" :key="index" class="list-group-item px-0">
            <div class="row align-items-center">
              <div class="col-sm-12 col-md-7">
                <p class="h5 mb-0">Fecha</p>
                <div class="medium mb-2">{{ date.date | date }}</div>
                <p class="h5 mb-0">Detalle</p>
                <div v-if="date.detail" class="medium mb-2">{{ date.detail }}</div>
                <div v-else class="medium mb-2">---</div>
              </div>
              <div class="col-sm-12 col-md-5">
                <base-button
                  class="d-block float-right m-1"
                  outline
                  size="sm"
                  type="danger"
                  @click="deleteConfirmation(date.id)"
                >
                  <i class="fas fa-trash"></i>
                </base-button>
                <base-button class="d-block float-right m-1" outline size="sm" type="success" @click="editDate(date)">
                  <i class="fas fa-pen"></i>
                </base-button>
              </div>
            </div>
          </li>
          <li v-if="dates.length === 0" class="list-group-item px-0">
            <div class="row align-items-center">
              <div class="col">
                <h4 class="mb-0">Esta Campaña no tiene fechas límites cargadas.</h4>
              </div>
            </div>
          </li>
        </ul>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';
import CampaignDatesBus from '../../../events/buses/campaign-dates.event';
import swal from 'sweetalert2';

export default {
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    dates: {
      type: Array,
      required: false,
      default: () => [],
    },

    campaignId: {
      type: Number,
      required: true,
    },
  },

  methods: {
    editDate(date) {
      CampaignDatesBus.edit(date);
    },

    deleteConfirmation(id) {
      swal({
        title: `Va a eliminar una fecha límite!`,
        text: `¿Está seguro que desea continuar?`,
        buttonsStyling: false,
        confirmButtonText: `Eliminar`,
        confirmButtonClass: 'btn btn-danger',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `Cancelar`,
        cancelButtonClass: 'btn btn-success',
      }).then((result) => {
        if (result.value) {
          this.deleteDate(id);
        }
      });
    },

    deleteDate(id) {
      this.$services
        .resource('campaign_dates')
        .delete(id)
        .then(() => {
          this.$success('La fecha fue eliminada con éxito', 'Eliminada!');
          this.$emit('dateDeleted', id);
        });
    },
  },
};
</script>
